import { get } from 'lodash-es';

export const getConfigureRatesModel = (state) => get(state, 'configureRatesModel');
export const getShowCreateLabelContent = (state) => get(state, 'showCreateLabelContent', false);
export const getModalId = (state) => get(state, 'modalId');
